import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const TimeoutRedirect = ({ children }) => {
  const navigate = useNavigate();
  const [lastActivity, setLastActivity] = useState(Date.now());
  const timerRef = useRef(null);

  const resetTimer = () => {
    setLastActivity(Date.now());
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      localStorage.clear();
      navigate("/sessionexpired");
    }, 30 * 60 * 1000);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [navigate]);

  return <>{children}</>;
};

export default TimeoutRedirect;
